
import React from 'react';
import { SheetHeader, SheetTitle } from '@/components/ui/sheet';

interface ChatHeaderProps {
  counterpartName: string;
  counterpartLogo?: string | null;
  getInitials: (name: string) => string;
  renderStatus: () => React.ReactNode;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  counterpartName,
  counterpartLogo,
  getInitials,
  renderStatus
}) => {
  return (
    <SheetHeader className="p-4 border-b">
      <div className="flex items-start gap-3">
        <div className="h-12 w-12 rounded-full overflow-hidden border-2 border-white shadow-md">
          {counterpartLogo ? (
            <img 
              src={counterpartLogo} 
              alt={counterpartName}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-muted">
              <span className="text-sm font-medium">{getInitials(counterpartName)}</span>
            </div>
          )}
        </div>
        <div className="flex flex-col gap-0.5">
          <SheetTitle className="text-left mb-0">{counterpartName}</SheetTitle>
          {renderStatus()}
        </div>
      </div>
    </SheetHeader>
  );
};

export default ChatHeader;
